import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Spin, message } from "antd";
import ReactApexChart from "react-apexcharts";
import { fetchTop3AlertGraphData } from "../../redux/slices/graphSlice";

const TravelDetailsView = () => {
  const dispatch = useDispatch();
  const [value, setValue] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const getPieChartList = async () => {
    try {
      const resultAction = await dispatch(fetchTop3AlertGraphData());
      if (fetchTop3AlertGraphData.fulfilled.match(resultAction)) {
        let {
          status,
          data: { response },
        } = resultAction.payload;
        if (status === 200) {
          setLoading(false);
          setCategories(response.labels);
          setValue(response.series);
        }
      } else {
        message.error(resultAction.payload || "Something went wrong");
      }
    } catch (error) {}
  };

  useEffect(() => {
    setLoading(true);
    getPieChartList();
  }, []);

  const chartOptions = {
    chart: {
      id: "apexchart-example",
      type: "pie",
      toolbar: {
        show: true,
      },
    },
    labels: categories,
    tooltip: {
      custom: function ({ seriesIndex }) {
        const alertName = categories[seriesIndex] || "Unknown";
        const alertCount = value[seriesIndex] || 0;
        return `<div style="padding: 10px; font-size: 12px; color: #333; background-color: white;">
                  <strong>Count:</strong> ${alertCount}<br>
                </div>`;
      },
    },
    colors: [
      "#3B3561",
      "#4481B3",
      "#187D8A",
      "#97C6FF",
      "#5D0202",
      "#7C769E",
      "#FC7A57",
      "#9D4F4F",
      "#EE9F9F",
      "#F5A27E",
      "#AC7070",
      "#5E9180",
      "#1E603A",
      "#6C915E",
    ],
    dataLabels: {
      enabled: true,
      style: {
        colors: ["#fff"],
      },
      offsetX: 30,
    },
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
          <span className="mx-3" style={{ color: "slategray" }}>
            Loading please wait...
          </span>
        </div>
      ) : (
        <div className="mt-3">
          <ReactApexChart
            options={chartOptions}
            series={value} // Pass the series array directly
            width="100%"
            height={300}
            type="pie"
          />
        </div>
      )}
    </>
  );
};

const ApexPieChartTop3Alert = () => {
  return <TravelDetailsView />;
};

export default ApexPieChartTop3Alert;
